import { Box, Paper, Stack, Tab, Tabs, Typography, useTheme } from "@mui/material"
import React, { useEffect } from "react";
import CustomTabPanel from "../components/CustomTabPanel";
import AFSClassificationList from "../components/afsClassification/AfsClassificationList";
import { AFSClassification, PPTClassification, PPTRamsesDescription, Reconciliation, TaxTerm } from "../helpers/interfaces";
import { getAllAFSClassifications, getAllPPTClassifications, getAllPPTRameses, getAllReconciliation, getAllTaxTerm } from "../apiServices/CTBMappingKeysApi";
import PPTClassificationList from "../components/pptClassification/PPTClassification";
import ReconciliationList from "../components/reconciliation/ReconciliationList";
import PPTRamses from "../components/pptRamses/PPTRamsesList";
import TaxTermList from "../components/taxTerm/TaxTermList";

function MappingKeys() {
    const theme = useTheme();
    const [selectedTabValue, setSelectedTabValue] = React.useState(1);
    const [afsClassification, setAfsClassification] = React.useState<AFSClassification[]>([])
    const [pptClassification, setPPTClassification] = React.useState<PPTClassification[]>([])
    const [reconciliation, setReconciliation] = React.useState<Reconciliation[]>([])
    const [pptRamses, setPPTRamses] = React.useState<PPTRamsesDescription[]>([])
    const [taxTerm, setTaxTerm] = React.useState<TaxTerm[]>([])
    useEffect(() => {
        getAllAFSClassifications().then(afs => setAfsClassification(afs))
        getAllPPTClassifications().then(ppt => setPPTClassification(ppt))
        getAllReconciliation().then(rec => setReconciliation(rec))
        getAllPPTRameses().then(ramses => setPPTRamses(ramses))
        getAllTaxTerm().then(tax => setTaxTerm(tax))
    }, [])

    return (
        <>
            <Box m="1.0rem 1.0rem">
                <Stack>
                    <Paper>
                        <Typography fontWeight="bold" sx={{ margin: '1.0rem', color: theme.palette.secondary.main, fontSize: '13px' }}>
                           CTB Mapping keys
                        </Typography>
                    </Paper >
                </Stack>
                <Box>
                    <br/>
                    <Paper>
                        <Box mt="10px" p='1.0rem' gap="20px">
                        <div>
                        <Tabs
                            variant="fullWidth" value={selectedTabValue} onChange={(event: any, newValue: any) => setSelectedTabValue(Number(newValue))} textColor="secondary"
                            indicatorColor="secondary" sx={{ fontWeight: 500 }}
                            aria-label="secondary tabs example">
                            <Tab label=" AFS Classification" value={1} />
                            <Tab label="PPT Classification" value={2} />
                            <Tab label="Reconciliation" value={3} />
                            <Tab label="PPT Ramses Desc" value={4} />
                            <Tab label="Tax Term" value={5} />
                        </Tabs>
                    </div>
                    <CustomTabPanel value={selectedTabValue} index={1} >
                        <div >
                        <AFSClassificationList setAfsClassification={setAfsClassification} afsClassification={afsClassification}/>
                        </div>
                    </CustomTabPanel>
                    <CustomTabPanel value={selectedTabValue} index={2} >
                        <div >
                        <PPTClassificationList setPPTClassification={setPPTClassification} pptClassification={pptClassification}/>
                        </div>
                    </CustomTabPanel>
                    <CustomTabPanel value={selectedTabValue} index={3} >
                        <div >
                        <ReconciliationList setReconciliation={setReconciliation} reconciliation={reconciliation}/>
                        </div>
                    </CustomTabPanel>
                    <CustomTabPanel value={selectedTabValue} index={4} >
                        <div >
                        <PPTRamses setPPTRamses={setPPTRamses} pptRamses={pptRamses}/>
                        </div>
                    </CustomTabPanel>
                    <CustomTabPanel value={selectedTabValue} index={5} >
                        <div >
                        <TaxTermList setTaxTerm={setTaxTerm} taxTerm={taxTerm}/>
                        </div>
                    </CustomTabPanel>
                        </Box>
                    </Paper>
                </Box>
            </Box>

        </>
    )
}
export default MappingKeys;